import {useEffect, useState} from "react";
import {findProductFreePairsWithPagination} from "../api/eventGroupApiClient";

export const useProductFreePairs = (page, pageSize, reloadTrigger) => {
    const [productFreePairs, setProductFreePairs] = useState([]);
    const [pagination, setPagination] = useState(null);

    useEffect(() => {
        const abortController = new AbortController();
        const productFreePairsWithPagination = findProductFreePairsWithPagination(page, pageSize, abortController.signal);

        productFreePairsWithPagination
            .then(
                (data) => {
                    const productFreePairs = data.productFreePairs;
                    const pagination = data.pagination;

                    setProductFreePairs(productFreePairs)
                    setPagination(pagination)
                }
            )
            .catch(
                (error) => console.log(error)
            );

        return () => {
            abortController.abort();
        };
    }, [page, pageSize, reloadTrigger]);

    return {productFreePairs : productFreePairs, pagination};
};